document.addEventListener('DOMContentLoaded', function () {
  // Check if the current page URL contains '/products'
  if (!window.location.pathname.includes('/products')) {
    console.log('Not a product page.');
    return;
  }

  console.log('This is a product page.');

  // Function to copy HTML content once elements are available
  function copyContent() {
    const descriptionBlock = document.querySelector(
      '.product__block.product__description.rte.aos-init.aos-animate'
    );

    const targetElement = document.querySelector(
      '.product__accordion > div > div > p'
    );

    if (descriptionBlock && targetElement) {
      console.log('Both elements found, copying content.');

      // Copy the HTML content
      targetElement.innerHTML = descriptionBlock.innerHTML;

      console.log('Content copied successfully.');

      // Disconnect the observer once content is copied
      observer.disconnect();
    }
  }

  // Set up a MutationObserver to monitor changes in the DOM
  const observer = new MutationObserver(copyContent);

  // Start observing the document body for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  console.log('Observer is set up and waiting for elements.');
});
